import { TSegmentedControlOption } from "@/components/elements/SegmentedControl/SegmentedControl";
import { EOrganizationStatus } from "@/constants/enum";

export type TOrganizationTabValue = "active" | "archived";

export const ORGANIZATION_TABS: TSegmentedControlOption<TOrganizationTabValue>[] = [
  { value: "active", label: "契約中組織" },
  { value: "archived", label: "アーカイブ済み" },
];

// Tabs filter by the organization lifecycle status (like the main organization list),
// not by product-contract status. A single org can hold contracts of mixed statuses,
// so contract-status filtering leaked archived orgs into the active tab and vice versa.
export const ORGANIZATION_TAB_STATUS: Record<TOrganizationTabValue, EOrganizationStatus> = {
  active: EOrganizationStatus.ACTIVE,
  archived: EOrganizationStatus.ARCHIVED,
};
